<template>
  <div>
    <AppShowChipBoxes
      v-if="item.rank && showRankAndStarts.length > 1"
      :items="showRankAndStarts"
      vertical
    />
    <template v-else-if="item.rank">
      {{ item.rank }}
    </template>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowChipBoxes from "@AppShows/AppShowChipBoxes.vue";
export default {
  name: "AppShowRankAndStarts",
  components: { AppShowChipBoxes },
  props: {
    item: {
      type: Object,
      default: () => ({
        rank: null,
        competition: {
          numberOfStarts: null
        }
      })
    }
  },
  computed: {
    showRankAndStarts() {
      return [
        { name: "rank", value: this.item.rank },
        this.item.competition?.numberOfStarts
          ? { name: "starts", value: this.item.competition.numberOfStarts }
          : undefined
      ].filter(Boolean);
    }
  },
  fragments: {
    rankStarts: gql`
      fragment _ on Result {
        rank
        competition {
          id
          numberOfStarts
        }
      }
    `
  }
};
</script>
